import { createContext } from 'react';

const SentenceContext = createContext();

SentenceContext.displayName = 'SentenceContext';

export default SentenceContext;
